// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__1wTUR","withIndication":"Icon_withIndication__1Pdd4"};